<template>
  <div class="entry-player-box">
    <!-- 顶部：标题 + 更多操作（预留） -->
    <div class="title">
      <div class="title-left">
        <img src="https://images.snsports.cn/FnJ1snSwn9lMILUeyaZ2WUTxK9gL" alt="个人参赛表" class="title-logo" />
      </div>
    </div>

    <!-- 第一块：球队 + 赛事信息（参考截图样式） -->
    <div class="card card-full card-team-match">
      <div class="row row-team">
        <span class="label">球队</span>
        <div class="value team">
          <div class="team-logo" v-if="team.badge">
            <img :src="imageView(team.badge)" alt="" />
          </div>
          <span class="team-name">{{ team.name || '-' }}</span>
        </div>
      </div>
      <div class="row row-match">
        <span class="label">赛事</span>
        <div class="value match">
          <div class="match-line">
            <span class="match-name">{{ match.chineseName || match.unionMatchName || '-' }}</span>
          </div>
          <div class="match-sub">
            <span>{{ project.matchGroupName || match.group || '-' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 第二块：个人资料 -->
    <div class="card-section">
      <div class="card card-full card-player" @click="goPlayerDetail">
        <div class="card-player-left">
          <div class="card-player-title">
            <span class="title-text">个人资料</span>
          </div>
          <div class="player-main">
            <div class="avatar" v-if="player.avatar">
              <img :src="imageView(player.avatar)" alt="" />
            </div>
            <div class="info">
              <div class="name">{{ player.trueName || '-' }}</div>
            </div>
          </div>
        </div>
        <div class="card-link">查看详情</div>
      </div>

      <!-- 参赛费用 + 协议 + 问卷：同一容器内 flex-wrap，默认一行两个，超过自动换行 -->
      <div
        v-if="showFeeRow || showAgreementCard || showSurveyCard"
        class="card-row card-row--stats"
      >
        <div
          v-if="showFeeRow"
          class="card card-fee"
          :class="statCardColClass"
          @click="goFeePayment"
        >
          <div class="card-title-row">
            <span class="card-title">参赛费用</span>
            <span class="card-link">{{ getPaymentStatus(player.orderStatus) }}</span>
          </div>
          <div class="card-desc">
            报名费：
            <span class="price">¥{{ feeAmountText }}</span>
          </div>
        </div>
        <EntryMiniStatCard
          v-if="showAgreementCard"
          layout="player"
          class="card card-agreement"
          :class="statCardColClass"
          title="协议/承诺书"
          :status-done="playerAgreementStatusDone"
          :count-line-done="playerAgreementCountLineDone"
          desc-class="agreement-count"
          :show-time-row="showAgreementTimeRow"
          :time-text="agreementBottomText"
          @click.stop="onAgreementCardClick"
        >
          <template #middle>已确认 {{ playerAgreementDone }}/{{ playerAgreementTotal }} 份</template>
        </EntryMiniStatCard>

        <EntryMiniStatCard
          v-if="showSurveyCard"
          layout="player"
          class="card card-survey"
          :class="statCardColClass"
          title="问卷/调研"
          :status-done="playerQuizStatusDone"
          :count-line-done="playerQuizCountLineDone"
          desc-class="survey-count"
          :show-time-row="showSurveyTimeRow"
          :time-text="surveyBottomText"
          @click.stop="onSurveyCardClick"
        >
          <template #middle>进度：已完成 {{ playerQuizDone }}/{{ playerQuizTotal }} 份</template>
        </EntryMiniStatCard>
      </div>
    </div>

    <EntryWxSubscribeRemind
      :visible="showWxSubscribeRemind"
      @click="goNotifySetting"
    />

    <!-- 底部：删除 + 领队代付（队员独立付费、未支付时，与 member-list 进入的 role=captain 一致） -->
    <div class="bottom-actions" v-if="playerId">
      <div class="left" @click.stop="cancelPlayer">
        <div class="img">
          <img src="@/assets/images/delete-icon.png" alt="删除" />
        </div>
        <div>删除</div>
      </div>
      <button
        v-if="showPayOnBehalfBtn"
        type="button"
        class="btn-pay-behalf"
        @click="goFeePayment"
      >
        代付报名费
      </button>
      <div v-else class="right-placeholder"></div>
    </div>
  </div>
</template>

<script>
import {
  getBMMatchTeamSignup,
  getBMMatchTeamPlayer,
  cancelBMMatchTeamPlayer,
  bangsaishiCreatePlayerSignupOrder,
  checkBMMatchBeforeSubmit,
  getBMMatchTeamPlayerAgreements,
  getBMMatchTeamPlayerQuestions,
  getCrmAccountWXSubscribeConfig
} from '@/api/match'
import { getThemeAccountId } from '@/libs/cookie-storage'
import { QNImageUtil } from '@/utils'
import { orderStatusOptions } from '@/config'
import {
  parseAgreementDate,
  formatAgreementMd,
  phaseFromBeginEnd,
  scheduleBottomText
} from '@/utils/entry-agreement-dates'
import { goWxSubscribeNotify } from '@/utils/wx-subscribe-notify'
import { Dialog, Toast } from 'vant'
import EntryWxSubscribeRemind from './EntryWxSubscribeRemind.vue'
import EntryMiniStatCard from './EntryMiniStatCard.vue'

export default {
  name: 'EntryInfoPlayer',
  components: { EntryWxSubscribeRemind, EntryMiniStatCard },
  data() {
    return {
      unionMatchId: '',
      matchId: '',
      teamId: '',
      playerId: '',
      match: {},
      project: {},
      team: {},
      player: {},
      playerAgreements: [],
      /** GetBMMatchTeamPlayerQuestions：isOpen、beginTime、endTime、list */
      questionsData: {
        isOpen: 0,
        beginTime: null,
        endTime: null,
        list: []
      },
      /** GetCrmAccountWXSubscribeConfig：isWxSubscribe、configList */
      wxSubscribe: {
        isWxSubscribe: 0,
        configList: []
      },
      /** 进入页仅弹一次：未完成协议/问卷且在可完成时段内 */
      incompleteRemindShown: false
    }
  },
  computed: {
    /** 报名费：xx.xx/人 */
    feeAmountText() {
      if (!this.match || !this.match.feeAmount) return '0.00'
      const amount = (this.match.feeAmount / 100).toFixed(2)
      return amount
    },
    /** GetBMMatchTeamSignup：match.isUseAgreement */
    showAgreementCard() {
      const m = this.match
      if (!m) return false
      return m.isUseAgreement === 1 || m.isUseAgreement === '1'
    },
    /** 组别启用问卷调研时展示（data.isOpen=1） */
    showSurveyCard() {
      const d = this.questionsData || {}
      return Number(d.isOpen) === 1
    },
    /** 队员独立付费卡片是否展示 */
    showFeeRow() {
      return !!(this.match && this.match.isOpenCharge === 1 && this.match.feeMethod === 1)
    },
    /** 费用 + 协议 + 问卷 同时展示的数量（用于一行两列 / 单列满宽） */
    statsCardCount() {
      let n = 0
      if (this.showFeeRow) n += 1
      if (this.showAgreementCard) n += 1
      if (this.showSurveyCard) n += 1
      return n
    },
    /** 仅 1 张时占满一行；2 张及以上时每张约 50% 宽度换行 */
    statCardColClass() {
      return this.statsCardCount > 1 ? 'card-half' : 'card-full'
    },
    surveyBeginTs() {
      return parseAgreementDate(this.questionsData && this.questionsData.beginTime)
    },
    surveyEndTs() {
      return parseAgreementDate(this.questionsData && this.questionsData.endTime)
    },
    surveyPhase() {
      return phaseFromBeginEnd(this.surveyBeginTs, this.surveyEndTs)
    },
    playerQuizList() {
      const raw = (this.questionsData && this.questionsData.list) || []
      return Array.isArray(raw) ? raw : []
    },
    playerQuizTotal() {
      return this.playerQuizList.length
    },
    playerQuizDone() {
      return this.playerQuizList.filter((q) => Number(q && q.completed) === 1).length
    },
    playerQuizStatusDone() {
      if (this.surveyPhase === 'before') return false
      if (this.playerQuizTotal <= 0) return false
      return this.playerQuizDone >= this.playerQuizTotal
    },
    playerQuizCountLineDone() {
      if (this.surveyPhase === 'before') return false
      if (this.playerQuizTotal <= 0) return false
      return this.playerQuizDone >= this.playerQuizTotal
    },
    surveyBottomText() {
      return scheduleBottomText(
        this.surveyPhase,
        this.surveyBeginTs,
        this.surveyEndTs,
        formatAgreementMd
      )
    },
    agreementBeginTs() {
      return parseAgreementDate(this.match && this.match.agreementBeginDate)
    },
    agreementEndTs() {
      return parseAgreementDate(this.match && this.match.agreementEndDate)
    },
    agreementPhase() {
      return phaseFromBeginEnd(this.agreementBeginTs, this.agreementEndTs)
    },
    playerAgreementTotal() {
      return this.playerAgreements.length
    },
    playerAgreementDone() {
      return this.playerAgreements.filter(a => Number(a && a.confirmed) === 1).length
    },
    /** 顶部右侧「已完成」：进行中/已截止 且 队员协议已全部确认；开启前未完成 */
    playerAgreementStatusDone() {
      if (this.agreementPhase === 'before') return false
      if (this.playerAgreementTotal <= 0) return false
      return this.playerAgreementDone >= this.playerAgreementTotal
    },
    playerAgreementCountLineDone() {
      if (this.agreementPhase === 'before') return false
      if (this.playerAgreementTotal <= 0) return false
      return this.playerAgreementDone >= this.playerAgreementTotal
    },
    agreementBottomText() {
      return scheduleBottomText(
        this.agreementPhase,
        this.agreementBeginTs,
        this.agreementEndTs,
        formatAgreementMd
      )
    },
    /** 无时间区间时不展示时钟行 */
    showAgreementTimeRow() {
      return this.agreementBottomText !== '—'
    },
    showSurveyTimeRow() {
      return this.surveyBottomText !== '—'
    },
    /** isWxSubscribe === 1 时展示消息提醒入口（与 entry-info 领队页一致） */
    showWxSubscribeRemind() {
      return Number(this.wxSubscribe.isWxSubscribe) === 1
    },
    /**
     * 队员独立付费 + 从名单以领队身份进入（member-list 带 role=captain）：展示底部「代付报名费」，逻辑与参赛费用卡片一致（goFeePayment）
     */
    showPayOnBehalfBtn() {
      if (this.$route.query.role !== 'captain') return false
      if (!this.showFeeRow || !this.playerId) return false
      const os = this.player && this.player.orderStatus
      if (os === 1 || os === 2) return false
      return true
    }
  },
  mounted() {
    this.unionMatchId = this.$route.query.unionMatchId
    this.matchId = this.$route.query.matchId
    this.teamId = this.$route.query.teamId
    this.playerId = this.$route.query.playerId
    this.loadData()
  },
  /** 从协议列表/确认页返回时若被缓存，刷新确认进度 */
  activated() {
    this.maybeRefreshPlayerAgreements()
    this.maybeRefreshPlayerQuestions()
  },
  methods: {
    /** GetCrmAccountWXSubscribeConfig：仅 query accountId（与 entry-info 一致） */
    fetchWxSubscribeConfig() {
      const accountId =
        (this.match && this.match.accountId) ||
        this.$route.query.accountId ||
        getThemeAccountId()
      if (accountId === '' || accountId == null) return
      getCrmAccountWXSubscribeConfig({ accountId, scene: 'match_single_signup' }).then(res => {
        if (!res) return
        const data = res.data != null ? res.data : res
        this.wxSubscribe = {
          isWxSubscribe: data.isWxSubscribe != null ? data.isWxSubscribe : 0,
          configList: Array.isArray(data.configList) ? data.configList : []
        }
      })
    },
    async goNotifySetting() {
      await goWxSubscribeNotify({
        wxSubscribe: this.wxSubscribe,
        matchId: this.matchId,
        teamId: this.teamId
      })
    },
    loadData() {
      const params = { matchId: this.matchId }
      if (this.teamId) params.teamId = this.teamId
      getBMMatchTeamSignup(params).then(res => {
        if (!res || !res.data) return
        const data = res.data
        this.match = data.match || {}
        this.project = data.match || {}
        this.team = data.team || {}
        this.maybeRefreshPlayerAgreements()
        this.maybeRefreshPlayerQuestions()
        this.fetchWxSubscribeConfig()
        this.$nextTick(() => this.maybeShowIncompleteRemindPlayer())
      })
      if (this.playerId) {
        getBMMatchTeamPlayer({ id: this.playerId }).then(res => {
          if (!res || !res.data) return
          const data = res.data
          this.player = data.player || {}
          this.maybeRefreshPlayerAgreements()
          this.maybeRefreshPlayerQuestions()
          this.$nextTick(() => this.maybeShowIncompleteRemindPlayer())
        })
      }
    },
    /** 未完成协议或问卷且对应项处于「进行中」可完成时段时提醒一次 */
    maybeShowIncompleteRemindPlayer() {
      if (this.incompleteRemindShown) return
      if (!this.matchId || !this.teamId || !this.playerId) return
      const needRemindAgreement =
        this.showAgreementCard &&
        this.playerAgreementTotal > 0 &&
        this.playerAgreementDone < this.playerAgreementTotal &&
        this.agreementPhase === 'during'
      const needRemindSurvey =
        this.showSurveyCard &&
        this.playerQuizTotal > 0 &&
        this.playerQuizDone < this.playerQuizTotal &&
        this.surveyPhase === 'during'
      if (!needRemindAgreement && !needRemindSurvey) return
      const ends = []
      if (needRemindAgreement && this.agreementEndTs) ends.push(this.agreementEndTs.getTime())
      if (needRemindSurvey && this.surveyEndTs) ends.push(this.surveyEndTs.getTime())
      this.incompleteRemindShown = true
      const msg =
        ends.length > 0
          ? `协议确认和问卷填写通道已开启，请在 ${formatAgreementMd(new Date(Math.min(...ends)))} 前完成相关操作`
          : '协议确认和问卷填写通道已开启，请在提交审核前完成相关操作'
      Dialog.alert({ message: msg, confirmButtonText: '确定' })
    },
    maybeRefreshPlayerQuestions() {
      if (!this.matchId || !this.teamId || !this.playerId) return
      this.fetchPlayerQuestions()
    },
    fetchPlayerQuestions() {
      if (!this.matchId || !this.teamId || !this.playerId) return
      getBMMatchTeamPlayerQuestions({
        matchId: this.matchId,
        teamId: this.teamId,
        playerId: this.playerId
      })
        .then((res) => {
          if (!res || res.data == null) {
            this.questionsData = { isOpen: 0, beginTime: null, endTime: null, list: [] }
            return
          }
          const d = res.data
          this.questionsData = {
            isOpen: d.isOpen,
            beginTime: d.beginTime != null ? d.beginTime : null,
            endTime: d.endTime != null ? d.endTime : null,
            list: Array.isArray(d.list) ? d.list : []
          }
        })
        .catch(() => {
          this.questionsData = { isOpen: 0, beginTime: null, endTime: null, list: [] }
        })
        .finally(() => {
          this.$nextTick(() => this.maybeShowIncompleteRemindPlayer())
        })
    },
    onSurveyCardClick() {
      if (!this.showSurveyCard) return
      if (this.surveyPhase === 'before') {
        Toast('问卷尚未开启')
        return
      }
      if (!this.playerId) {
        Toast.fail('缺少队员信息，请稍后重试')
        return
      }
      this.$router.push({
        path: '/entry-page/player-quiz-list',
        query: {
          unionMatchId: this.unionMatchId,
          matchId: this.matchId,
          teamId: this.teamId,
          playerId: this.playerId
        }
      })
    },
    /**
     * 队员协议进度依赖：报名配置 match（含 isUseAgreement、协议期）+ playerId。
     * 在 signup / 队员详情 任一侧就绪后尝试拉列表，避免仅一方返回时漏请求。
     */
    maybeRefreshPlayerAgreements() {
      if (!this.matchId || !this.teamId || !this.playerId) return
      if (!this.showAgreementCard) return
      this.fetchPlayerAgreements()
    },
    fetchPlayerAgreements() {
      if (!this.showAgreementCard) return
      if (!this.matchId || !this.teamId || !this.playerId) return
      getBMMatchTeamPlayerAgreements({
        matchId: this.matchId,
        teamId: this.teamId,
        playerId: this.playerId
      }).then(res => {
        if (!res) {
          this.playerAgreements = []
          return
        }
        const raw = res.data
        const list = Array.isArray(raw)
          ? raw
          : Array.isArray(raw && raw.list)
            ? raw.list
            : Array.isArray(raw && raw.agreements)
              ? raw.agreements
              : []
        this.playerAgreements = list
      })
        .finally(() => {
          this.$nextTick(() => this.maybeShowIncompleteRemindPlayer())
        })
    },
    onAgreementCardClick() {
      if (!this.showAgreementCard) return
      if (this.agreementPhase === 'before') {
        Toast('协议确认尚未开启')
        return
      }
      if (!this.playerId) {
        Toast.fail('缺少队员信息，请稍后重试')
        return
      }
      this.$router.push({
        path: '/entry-page/agreement-list',
        query: {
          type: 'player',
          teamId: this.teamId,
          matchId: this.matchId,
          unionMatchId: this.unionMatchId,
          playerId: this.playerId
        }
      })
    },
    imageView(img) {
      if (!img) return ''
      return QNImageUtil.imageView(img)
    },
    getPaymentStatus(value) {
      const order = orderStatusOptions.find(o => o.value === value)
      return order?.label || '待支付'
    },
    /**
     * 参赛费用：GetBMMatchTeamPlayer.player 有 orderId 则去支付；否则校验后创建队员订单再跳转。
     */
    goFeePayment() {
      if (!this.showFeeRow || !this.playerId || !this.matchId || !this.teamId) return
      getBMMatchTeamPlayer({ id: this.playerId }).then(res => {
        if (!res || !res.data) return
        const player = res.data.player || {}
        if (player.orderId) {
          this.$router.push(
            `/entry-page/payment?orderId=${player.orderId}&unionMatchId=${this.unionMatchId}&category=1&matchId=${this.matchId}&teamId=${this.teamId}&playerId=${this.playerId}`
          )
          return
        }
        checkBMMatchBeforeSubmit({ teamId: this.teamId, matchId: this.matchId }).then(ok => {
          if (!ok) return
          bangsaishiCreatePlayerSignupOrder({
            matchId: this.matchId,
            teamId: this.teamId,
            playerId: this.playerId
          }).then(r => {
            if (r && r.data && r.data.orderId) {
              this.$router.push(
                `/entry-page/payment?orderId=${r.data.orderId}&unionMatchId=${this.unionMatchId}&category=1&matchId=${this.matchId}&teamId=${this.teamId}&playerId=${this.playerId}`
              )
            }
          })
        })
      })
    },
    goPlayerDetail() {
      this.$router.push(`/entry-page/player-info?teamId=${this.teamId}&matchId=${this.matchId}&unionMatchId=${this.unionMatchId}&playerId=${this.playerId || ''}&role=captain`)
    },
    // 取消球员报名（逻辑与 player-info.vue 保持一致）
    cancelPlayer() {
      const orderStatus = this.player && this.player.orderStatus
      if (orderStatus === 1 || orderStatus === 2) {
        Toast.fail('已支付报名费用，取消报名请联系组委会')
        return
      }
      Dialog.confirm({
        title: '提示',
        message: `是否确定要取消${this.player.trueName || ''}的报名吗？`,
      }).then(() => {
        const params = {
          matchId: this.matchId,
          teamId: this.teamId,
          playerId: this.playerId
        }
        cancelBMMatchTeamPlayer(params).then(res => {
          if (res) {
            Toast('取消成功')
            this.$router.back()
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.entry-player-box {
  background: var(--bg2);
  min-height: 100vh;
  padding: 12px 14px 100px;
  box-sizing: border-box;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left {
      display: flex;
      align-items: center;
      .title-logo {
        width: 95px;
        height: 22px;
        display: block;
      }
      .title-text {
        margin-left: 8px;
        font-size: 14px;
        font-weight: bold;
        color: #3D3D3D;
      }
    }
  }

  .card {
    background: #fff;
    border-radius: 8px;
    padding: 14px 16px;
    // margin-top: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .card-team-match {
    flex-direction: column;
    align-items: stretch;
    border: 1px solid #DEDEDE;
    .row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      font-size: 13px;
      color: #666;
      & + .row {
        margin-top: 6px;
      }
      .label {
        flex-shrink: 0;
        min-width: 40px;
        font-size: 14px;
        font-weight: bold;
        color: #3D3D3D;
      }
      .value {
        // flex: 1;
        font-size: 15px;
        min-width: 0;
      }
      .team {
        display: flex;
        align-items: center;
        .team-logo {
          width: 25px;
          height: 25px;
          overflow: hidden;
          background: #e8e8e8;
          margin-right: 8px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      .match-line {
        font-size: 14px;
        color: #1d2129;
      }
      .match-sub {
        text-align: right;
        font-size: 12px;
        color: #999;
        margin-top: 8px;
      }
    }
    .row-team {
      align-items: center;
    }
    .row-match {
      margin-top: 12px !important;
    }
  }

  .card-section {
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .card{
      background-color: var(--bg1);
    }
    .card-row {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: stretch;
      gap: 12px;
      margin-top: 12px;
      width: 100%;
      box-sizing: border-box;
    }
    /* 费用+协议+问卷：一行两个，超出换行（与 entry-info 半卡视觉一致） */
    .card-row--stats {
      flex: 0 0 100%;
    }
    .card-half {
      flex: 0 0 calc(50% - 6px);
      width: calc(50% - 6px);
      max-width: calc(50% - 6px);
      min-width: 0;
      height: 105px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
    }
    .card-agreement.card-half,
    .card-survey.card-half {
      align-items: stretch;
      justify-content: flex-start;
      min-height: 105px;
      height: auto;
    }
    .card-title-row{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .card-title{
        margin-bottom: 0;
        font-size: 15px;
        font-weight: 500;
        color: #1d2129;
      }
      .card-link{
        flex-shrink: 0;
        margin-left: 8px;
        font-size: 14px;
        color: #1989fa;
      }
    }
    .card-player {
      margin-bottom: 12px;
      width: 100%;

      .card-player-left {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        .card-player-title {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          .title-text {
            font-size: 15px;
            font-weight: 500;
            color: #1d2129;
          }
        }
        .player-main {
          display: flex;
          align-items: center;
        }
        .avatar {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          overflow: hidden;
          background: #e8e8e8;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .info {
          margin-left: 12px;
          .name {
            font-size: 15px;
            font-weight: 500;
            color: #1d2129;
          }
        }
      }
      .card-link {
        font-size: 14px;
        color: #1989fa;
        flex-shrink: 0;
      }
    }

    .card-fee.card-half {
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      height: auto;
      min-height: 105px;
    }
    .card-fee {
      flex-direction: column;
      align-items: stretch;
      cursor: pointer;
      .card-desc {
        margin-top: 6px;
        font-size: 13px;
        color: #666;
        .price {
          font-size: 15px;
          font-weight: 500;
          color: #1d2129;
        }
      }
    }

    .card-survey,
    .card-agreement {
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
    }
    .card-full {
      width: 100%;
      flex: 1 1 100%;
      max-width: 100%;
      min-height: 98px;
      box-sizing: border-box;
    }
  }

  /* 底部操作区：删除按钮样式与 player-info.vue 保持一致 */
  .bottom-actions {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 12px 16px;
    padding-bottom: 26px;
    background-color: #ffffff;
    border-top: 0.5px solid #eeeeee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      font-size: 11px;
      color: #3d3d3d;
      text-align: center;
      .img {
        width: 27px;
        height: 27px;
        background: #e3f1ff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 3px;
        img {
          width: 14px;
          height: 14px;
        }
      }
    }
    .right-placeholder {
      width: 111px;
      height: 37px;
    }
    .btn-pay-behalf {
      flex-shrink: 0;
      min-width: 120px;
      height: 40px;
      padding: 0 18px;
      line-height: 40px;
      border: none;
      border-radius: 20px;
      background: #7c5cff;
      color: #fff;
      font-size: 15px;
      font-weight: 500;
      box-shadow: 0 2px 8px rgba(124, 92, 255, 0.35);
    }
    .btn-pay-behalf:active {
      opacity: 0.9;
    }
  }
}
</style>

